/**
 * Class for expandable text module
 */
class ExpandableText {
	/**
	 * This runs on load
	 */
	constructor() {
		this.moduleWrapperClass = '.module-gc-expand-text';
		this.moduleContentClass = '.gtc-expendable-text-content';
		this.btn = document.querySelectorAll('.gtc-expendable-text-toggle .btn');
	}

	/**
	 * Initialize function
	 *
	 * @return {void}
	 */
	init() {
		this.addEventListners();
	}

	/**
	 * Eventlisteners
	 *
	 * @return {void}
	 */
	addEventListners() {
		this.btn.forEach((item) => {
			item.addEventListener('click', this.handleClick.bind(this));
		});
	}

	/**
	 * handle click function
	 *
	 * @param {Event} e
	 * @return {void}
	 */
	handleClick(e) {
		this.moduleWrapper = e.target.closest(this.moduleWrapperClass);
		this.moduleContentWrapper = e.target.closest(this.moduleWrapperClass).querySelector(this.moduleContentClass);

		if (!this.moduleWrapper.classList.contains('open')) {
			Helper.slideDown(this.moduleContentWrapper);
			this.moduleWrapper.classList.add('open');
		} else {
			Helper.slideUp(this.moduleContentWrapper);
			this.moduleWrapper.classList.remove('open');
		}
	}
}

const runExpandableText = () => {
	if (document.querySelector('.module-gc-expand-text')) {
		const expandableText = new ExpandableText();
		expandableText.init();
	}
};

// If document is already ready
if (document.readyState === 'complete') {
	runExpandableText();
} else {
	document.addEventListener('DOMContentLoaded', runExpandableText);
}
